import { useNavigate } from 'react-router-dom'

// antd
import { Typography } from 'antd'

// components
import Button from '../../components/button/button'

// assets
import { SuccessfullyPasswordIcon } from '../../assets/icons'
import logo from '../../assets/images/logo.png'

// routes
import { PUBLIC_ROUTES } from '../../routes'

// css
import './LoginForm.css'

function SuccessfullyResetPassword() {
    const navigate = useNavigate()
    const { Text } = Typography

    return (
        <div className="glass-card">
            <div className="login-logo-container">
                <img src={logo} alt="logo" className="login-form-logo-img" />
            </div>

            <SuccessfullyPasswordIcon />

            <div
                style={{
                    margin: '28px 0 34px',
                    textAlign: 'center',
                }}
            >
                <h2 className="welcome-title" style={{ marginBottom: 6 }}>
                    Password Reset Successful
                </h2>
                <Text className="welcome-subtitle" style={{ marginBottom: 0 }}>
                    Your password has been reset successfully.
                </Text>
            </div>

            <Button
                props={{
                    text: 'Continue',
                    onClick: () => navigate(PUBLIC_ROUTES.login),
                    className: 'login-submit-btn',
                }}
            />
        </div>
    )
}

export default SuccessfullyResetPassword
